import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as Tabs from "@radix-ui/react-tabs";
import Header from "../Header";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import {ReactComponent as Filter} from "../../assets/svg/filter-funnel-02.svg";
import {ReactComponent as Heart} from "../../assets/svg/heart.svg";
import {ReactComponent as List} from "../../assets/svg/list.svg";
import {ReactComponent as Route} from "../../assets/svg/route.svg";
import {ReactComponent as UserCircle} from "../../assets/svg/user-circle.svg";
import {ReactComponent as Users} from "../../assets/svg/users-03.svg";
import {Link} from "react-router-dom";
import {useState} from "react";
import {Profile} from "./Profile";
import {MyTeam} from "./MyTeam";
import {MyTeamActivity} from "./MyTeamActivity";

export const User = () => {
    const [selectedTab, setSelectedTab] = useState("Profile");
    return (
        <div>
            <Header/>

            <main className="container mx-auto mt-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-x-4">
                        <Link
                            to={"/"}
                            className="w-10 h-10 border text-gray-700 flex items-center justify-center"
                        >
                            <FontAwesomeIcon icon={faChevronLeft}/>
                        </Link>
                        <h2 className="text-2xl font-semibold text-gray-900 m-0">
                            {selectedTab}
                        </h2>
                    </div>

                    {selectedTab === "Profile" ? (
                        <div className="flex items-center gap-x-6">
                            <button className="text-gray-600 text-sm font-semibold">
                                Cancel
                            </button>
                            <button className="bg-primary px-4 py-2 text-white font-semibold text-sm">
                                Save Changes
                            </button>
                        </div>
                    ) : null}
                </div>

                <div className="mt-6">
                    <Tabs.Root
                        orientation="vertical"
                        defaultValue="general"
                        className="flex gap-x-8"
                    >
                        <Tabs.List>
                            <Tabs.Trigger
                                value="general"
                                className="flex items-center gap-x-3 font-semibold text-gray-700 radix-state-active:text-gray-800 px-3 py-2 w-full hover:bg-gray-100 radix-state-active:bg-gray-100"
                                onClick={() => setSelectedTab("Profile")}
                            >
                                <span>
                                    <UserCircle/>
                                </span>
                                <span>Profile</span>
                            </Tabs.Trigger>

                            <Tabs.Trigger
                                value="team"
                                className="flex items-center gap-x-3 font-semibold text-gray-700 radix-state-active:text-gray-800 px-3 py-2 w-full hover:bg-gray-100 radix-state-active:bg-gray-100"
                                onClick={() => setSelectedTab("My Team")}
                            >
                                <span>
                                    <Users/>
                                </span>
                                <span>My Team</span>
                            </Tabs.Trigger>

                            <Tabs.Trigger
                                value="owner"
                                className="flex items-center gap-x-3 font-semibold text-gray-700 radix-state-active:text-gray-800 px-3 py-2 w-full hover:bg-gray-100 radix-state-active:bg-gray-100"
                                onClick={() => setSelectedTab("My Team Activity")}
                            >
                                <span>
                                    <List/>
                                </span>
                                <span>My Team Activity</span>
                            </Tabs.Trigger>

                            <Tabs.Trigger
                                value="loan"
                                className="flex items-center gap-x-3 font-semibold text-gray-700 radix-state-active:text-gray-800 px-3 py-2 w-full hover:bg-gray-100 radix-state-active:bg-gray-100"
                                onClick={() => setSelectedTab("Manage Leads")}
                            >
                                <span>
                                    <Filter/>
                                </span>
                                <span>Manage Leads</span>
                            </Tabs.Trigger>

                            <Tabs.Trigger
                                value="offer"
                                className="flex items-center gap-x-3 font-semibold text-gray-700 radix-state-active:text-gray-800 px-3 py-2 w-full hover:bg-gray-100 radix-state-active:bg-gray-100"
                                onClick={() => setSelectedTab("Routes")}
                            >
                                <span>
                                    <Route/>
                                </span>
                                <span>Routes</span>
                            </Tabs.Trigger>

                            <Tabs.Trigger
                                value="fav"
                                className="flex items-center gap-x-3 font-semibold text-gray-700 radix-state-active:text-gray-800 px-3 py-2 w-full hover:bg-gray-100 radix-state-active:bg-gray-100"
                                onClick={() => setSelectedTab("Favourite")}
                            >
                                <span>
                                    <Heart/>
                                </span>
                                <span>Favourite</span>
                            </Tabs.Trigger>
                        </Tabs.List>
                        <Tabs.Content value="general" className="flex-1">
                            <Profile/>
                        </Tabs.Content>
                        <Tabs.Content value="team" className="flex-1">
                            <MyTeam/>
                        </Tabs.Content>
                        <Tabs.Content value="owner" className="flex-1">
                            <MyTeamActivity/>
                        </Tabs.Content>
                        {/* <Tabs.Content value="loan" className="flex-1">
              <LoanInfo />
            </Tabs.Content>
            <Tabs.Content value="offer" className="flex-1">
              <OfferDetails />
            </Tabs.Content> */}
                    </Tabs.Root>
                </div>
            </main>
        </div>
    );
};
